import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const DURATION = 2 * 60 * 60 * 1000; // 2 hours in ms
    const STORAGE_KEY = 'fabrica_countdown_start';
    let startTime = localStorage.getItem(STORAGE_KEY);
    if (!startTime) {
      startTime = Date.now().toString();
      localStorage.setItem(STORAGE_KEY, startTime);
    }
    const calculateTimeLeft = () => {
      const now = Date.now();
      const difference = parseInt(startTime!) + DURATION - now;
      if (difference <= 0) {
        setIsExpired(true);
        return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      return {
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!mounted) return null;
  if (isExpired) {
    return <span className="text-red-500 font-bold" data-id="element-61">¡Oferta expirada!</span>;
  }
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (compact) {
    return <span className="text-white font-black tracking-wider" data-id="element-62">
        {formatNumber(timeLeft.hours)}:{formatNumber(timeLeft.minutes)}:
        {formatNumber(timeLeft.seconds)}
      </span>;
  }
  return <div className="flex items-center justify-center gap-3 sm:gap-4" data-id="element-63">
      <div className="flex flex-col items-center" data-id="element-64">
        <div className="bg-[rgba(255,107,0,0.15)] border border-orange rounded-lg w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mb-2 shadow-[0_0_15px_rgba(255,107,0,0.2)]" data-id="element-65">
          <span className="text-orange font-black text-3xl sm:text-4xl" data-id="element-66">
            {formatNumber(timeLeft.hours)}
          </span>
        </div>
        <span className="text-[11px] text-gray-400 uppercase font-bold tracking-wider" data-id="element-67">
          Horas
        </span>
      </div>
      <div className="text-orange font-black text-3xl sm:text-4xl pb-6" data-id="element-68">:</div>
      <div className="flex flex-col items-center" data-id="element-69">
        <div className="bg-[rgba(255,107,0,0.15)] border border-orange rounded-lg w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mb-2 shadow-[0_0_15px_rgba(255,107,0,0.2)]" data-id="element-70">
          <span className="text-orange font-black text-3xl sm:text-4xl" data-id="element-71">
            {formatNumber(timeLeft.minutes)}
          </span>
        </div>
        <span className="text-[11px] text-gray-400 uppercase font-bold tracking-wider" data-id="element-72">
          Minutos
        </span>
      </div>
      <div className="text-orange font-black text-3xl sm:text-4xl pb-6" data-id="element-73">:</div>
      <div className="flex flex-col items-center" data-id="element-74">
        <div className="bg-[rgba(255,107,0,0.15)] border border-orange rounded-lg w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mb-2 shadow-[0_0_15px_rgba(255,107,0,0.2)]" data-id="element-75">
          <span className="text-orange font-black text-3xl sm:text-4xl" data-id="element-76">
            {formatNumber(timeLeft.seconds)}
          </span>
        </div>
        <span className="text-[11px] text-gray-400 uppercase font-bold tracking-wider" data-id="element-77">
          Segundos
        </span>
      </div>
    </div>;
}